var map = {
	"./datasets/main.js": 1240,
	"./models/main.js": 1241,
	"./permissions/main.js": 1242,
	"./rename_variables/main.js": 1248,
	"./select_table/main.js": 1243,
	"./tables/main.js": 1244,
	"./view_head_of_raw_data/main.js": 1245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2773;